import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {useParams} from "react-router-dom";
import { useLocaleContext } from "../../../../../context/LocaleContext";
import Breadcrumbs from "../../../../UI/Breadcrumbs";
import Loading from '../../../../Loading';
import SettingsSidebar from "../components/SettingsSidebar";
import RegistraionEmbedCode from "../components/RegistrationEmbedCode";
import RegistrationPreview from "../components/RegistrationPreview";
import { getWidgetRegistration } from "../../../../../../api/player";

const WidgetEditor = ({event}) => {
    const {widgetKey} = useParams();
    const {localeName} = useLocaleContext();
    const [settings, setSettings] = useState(null);
    const [params, setParams] = useState(null);
    const [isFormVisible, setFormVisible] = useState(true);
    const [isPreviewUpdated, setPreviewUpdated] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const breadcrumbs = [
        'mainMenu.widgets',
        'mainMenu.widget.registrationConstructor',
        'mainMenu.widget.update',
    ];

    useEffect(() => {
        fetchWidgetSetting();
    }, [event]);

    useEffect(() => {
        setParams({
            ...params,
            widget: widgetKey,
            backgroundColor: settings?.backgroundColor,
            backgroundOpacityPercent: settings?.backgroundOpacityPercent,
            colorAccent: settings?.colorAccent,
            lang: settings?.lang || null,
        });
    }, [settings]);

    async function fetchWidgetSetting() {
        try {
            setLoading(true);

            const response = await getWidgetRegistration(widgetKey);
            setSettings(response);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const handleUpdateSettings = (value) => {
        setSettings({
            ...settings,
            ...value,
        });
    };

    const handleChangeDisplay = () => {
        setPreviewUpdated(true);

        const timer = setTimeout(() => {
            setPreviewUpdated(false);
            clearTimeout(timer);
        }, 0);
    };

    return (
        isLoading
            ? <Loading />
            : <>
                <Breadcrumbs
                    link={`/event/${event.eventPassword}`}
                    activeCrumbs={breadcrumbs}
                />
                <div style={{marginBottom: '60px', display: 'flex', columnGap: '40px'}}>
                    <div style={{width: '36%'}}>
                        <SettingsSidebar
                            eventKey={event.eventKey}
                            eventPassword={event.eventPassword}
                            eventName={event[`name_${localeName}`]}
                            accessPreModeration={event.moduleAuth.accessPreModeration}
                            eventSettings={settings}
                            widgetKey={widgetKey}
                            participationType={event.participationType}
                            registrationType={event.moduleAuth.registrationType ?? 'hybrid'}
                            isFormVisible={isFormVisible}
                            onUpdateModel={handleUpdateSettings}
                            onUpdatePreview={handleChangeDisplay}
                            onChangeScreen={setFormVisible}
                        />
                    </div>
                    <div style={{width: '64%'}}>
                        <RegistraionEmbedCode
                            eventKey={event.eventKey}
                            params={params}
                        />
                        <RegistrationPreview
                            event={event}
                            settings={settings}
                            params={{...params, isFormVisible}}
                            isFormVisible={isFormVisible}
                            isPreviewUpdated={isPreviewUpdated}
                        />
                    </div>
                </div>
            </>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent
    };
};

export default connect(mapStateToProps)(WidgetEditor);
